import './Divider.scoped.scss'

export default function Divider() {
  return <hr />
}
